import moment from "moment"
import { useEffect, useState } from "react"
import { private_server } from "../../../config"
import {  onGetErrorMessage, updateAuthorizationHeader } from "../../../shared/utility"

const useUserDetailsView = ({user, history, match}) => {
    const [loading, setLoading] = useState(false)
    const [sending, setSending] = useState(false)
    const [profile_view, setProfileView] = useState(false)

    const [error, setError] = useState(null)

    const [users, setUsers] = useState([])
    const [total, setTotal] = useState(10)

    const [selected_user, setSelectedUser] = useState(null)

    const [query, setQuery] = useState('')
    const [tableFilter, setTableFilter] = useState({
        limit:10,
        offset:0,
        order:1,
        order_by:'_id',
        user_type_id:1
    })


    const [modals, setModals] = useState({
        add_user:false,
        edit_user:false,
        change_password:false,
        change_avatar:false,
    })

    useEffect(()=>{window.scrollTo(0,0)},[])

    useEffect(() => {
        if(user) actions.onInitModule()
    }, [user])

    const onGetUserID = () => {
        let isprofile = true
        if(history) isprofile = !(history.location.pathname.includes('/users/'))
        let user_id = isprofile ? user._id : match.params.id
        setProfileView(isprofile)
        return user_id
    }

    const actions = {
        onInitModule: async() => {
            try {
                setLoading(true)
                let user_id = onGetUserID()
                const _user = await private_server.get(`/user/${user_id}`)
                setSelectedUser(_user.data.data.user)
                setLoading(false)
                
            } catch (error) {
                setLoading(false)
                console.log(error)
                const _error = onGetErrorMessage(error)
                setError(_error ? _error.message : null)
            }
        },
        onRefreshData: async() => {
            try {
                let user_id = onGetUserID()
                const _user = await private_server.get(`/user/${user_id}`)
                console.log(_user.data.data.user)
                setSelectedUser(_user.data.data.user)
            } catch (error) {
                console.log(error)
                const _error = onGetErrorMessage(error)
                setError(_error ? _error.message : null)
            }
        },
        onUpdateUsers: async() => {
            try {
                let user_id = onGetUserID()
                const _user = await private_server.get(`/user/by/${user_id}`)
                console.log(user)
                setSelectedUser(_user.data.data)
            } catch (error) {
                console.log(error)
                const _error = onGetErrorMessage(error)
                setError(_error ? _error.message : null)
            }
            
        },
        onUpdateQuery:(data) => {
            setQuery(data)
        },
        onSelectedItem: () => {

        },
        onSelectedItem: async(data) => {
            console.log('Disparar busqueda')
            const _user = await private_server.get(`/user/by/${data._id}`)
            console.log(user)
            setSelectedUser(_user.data.data)
            actions.onUpdateModal({edit_user:true})
        },
        onChangeFilter: () => {

        },
        onUpdateUser: (data) => {
            setSelectedUser(data)
        },
        onUpdateTableFilter: (data) => {
            setTableFilter(data)
        },
        onUpdateModal: (_key, _value) => {
            let _modals = {...modals, [_key]:_value}
            setModals(_modals)
        },
        onClearError: () => setError(null)

    }

    const system = {loading, sending, error}
    const view_data = {users, selected_user, query, tableFilter, total, profile_view}

    return {system, modals, view_data, actions}
}

export default useUserDetailsView